<form
  class="flex flex-col items-center justify-center form-wrapper -mb-2"
  [formGroup]="form"
  (ngSubmit)="otpStep ? verifyConsultationOTP() : sendConsultationOTP()"
  [ngClass]="animation ? 'animation-move-right-reverse' : 'animation-move-right'"
>

  <!-- مرحله اول: اطلاعات مشاوره -->
  <ng-container *ngIf="!otpStep">

    <div class="form-grid w-full lg:w-[85%] md:w-[70%]">

      <div class="input-cell">
        <input
          id="firstName"
          formControlName="firstName"
          placeholder="نام"
          class="input-small"
        />
      </div>

      <div class="input-cell">
        <input
          id="lastName"
          formControlName="lastName"
          placeholder="نام خانوادگی"
          class="input-small"
        />
      </div>

      <div class="input-cell">
        <input
          id="phoneNumber"
          formControlName="phoneNumber"
          placeholder="شماره تماس"
          class="input-small"
          inputmode="numeric"
        />
      </div>

      <div class="input-cell">
        <input
          id="Email"
          formControlName="Email"
          placeholder="ایمیل"
          class="input-small"
          type="email"
        />
      </div>

    </div>

    <div class="w-full lg:w-[85%] md:w-[70%] mt-3">
      <textarea
        id="description"
        formControlName="description"
        placeholder="توضیحات"
        class="input-small textarea-consultation"
      ></textarea>
    </div>

    <div class="w-full lg:w-[85%] md:w-[70%] mt-3 flex items-center justify-center">
      <button
        type="submit"
        aria-label="ارسال کد تایید"
        class="btn-form btn-full"
        [disabled]="otpSending"
      >
        <p class="text-[#061fb8] font-bold text-sm">
          {{ otpSending ? 'در حال ارسال...' : 'ارسال کد تأیید' }}
        </p>
      </button>
    </div>

  </ng-container>


  <!-- مرحله دوم: تایید OTP -->
  <ng-container *ngIf="otpStep">

    <div class="otp-consultation-wrapper w-full lg:w-[85%] md:w-[70%]">

      <div class="otp-consultation-title">
        <p>
          کد تأیید به شماره موبایل شما ارسال شد.
        </p>

        <p class="otp-consultation-phone">
          {{ form.controls['phoneNumber']?.value }}
        </p>
      </div>

      <div class="otp-consultation-input-wrapper">
        <input
          type="text"
          inputmode="numeric"
          maxlength="4"
          autocomplete="one-time-code"
          class="otp-consultation-input"
          placeholder="----"
          [value]="otpCode"
          (input)="fillOtpValue($any($event.target).value)"
        />
      </div>

      <div
      
      class="otp-consultation-cooldown"
      *ngIf="otpCooldown > 0"
    >
      <span class="otp-consultation-cooldown-icon">↻</span>
      <span>ارسال مجدد کد</span>
      <strong>{{ otpCooldown }}</strong>
      <span>ثانیه دیگر</span>
    </div>

    <button
      *ngIf="otpCooldown === 0"
      type="button"
      class="otp-consultation-resend"
      [disabled]="otpSending"
      (click)="sendConsultationOTP()"
    >
      {{ otpSending ? 'در حال ارسال...' : 'ارسال مجدد کد تأیید' }}
    </button>

      <div class="w-full flex items-center justify-center mt-3">
        <button
          type="submit"
          aria-label="تأیید و ثبت درخواست"
          class="btn-form btn-full"
          [disabled]="otpSending || otpCode.length !== 4"
        >
          <p class="text-[#061fb8] font-bold text-sm">
            {{ otpSending ? 'در حال بررسی...' : 'تأیید و ثبت درخواست' }}
          </p>
        </button>
      </div>

      <div class="otp-back-wrapper">
        <button
          type="button"
          class="otp-back-button"
          (click)="backToConsultationForm()"
          [disabled]="otpSending"
        >
          تغییر شماره موبایل
        </button>
      </div>

    </div>

  </ng-container>

</form>